export default function IconCompareSettings () {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M2.6499 3H13.3501C13.9024 3 14.3501 3.44773 14.3501 4.00001V13.5C14.3501 14.0523 13.9024 14.5 13.3501 14.5H2.6499C2.09762 14.5 1.6499 14.0523 1.6499 13.5V4.00001C1.6499 3.44773 2.09762 3 2.6499 3ZM7.3499 4.30001V6.4L2.9499 6.4L2.9499 4.30001H7.3499ZM7.3499 7.70001V9.80001H2.9499L2.9499 7.70001H7.3499ZM7.3499 13.2V11.1H2.9499L2.9499 13.2H7.3499ZM8.6501 6.4V4.30001H13.0501V6.4L8.6501 6.4ZM8.6501 7.70001V9.80001H13.0501V7.70001H8.6501ZM8.6501 13.2V11.1H13.0501V13.2H8.6501Z"
            fill="#7E8681"/>
    </svg>
  )
}
